import React, { useState, useContext, useEffect } from 'react';
import { Wrap, WrapInput, WrapList } from '../../components/Wrap';
import { Input,LabelInput, inputStyle,multSelect } from '../../components/Input';
import { SearchBox, IconeSearch, ItemsSearch } from "../../components/Search";
import { Button, CancelarBtn } from "../../components/Button";
import { Container, TitleStyle2,Items} from './styles'
import { HeaderList, BodyList } from '../../components/TabelaCadastro';
import { Modal, CircularProgress } from "@material-ui/core";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import { Table, TableBody, TableCell, TableHead, TableRow, TableContainer } from '../../components/SharedComponents/table';
import { shade } from 'polished'
import { AiOutlineDelete, AiOutlineEdit,AiOutlineTeam,AiTwotoneDelete } from "react-icons/ai";
import { ThemeContext } from 'styled-components';
import { ERRORMESSAGE, SUCCESSMESSAGE, INFOMESSAGE } from '../../utils/types-messages';
import { useSnackbar } from 'notistack';
import { api } from '../../services/axios';
import { makeStyles } from '@material-ui/core/styles';
import { modalClose, ModalBox, StyledBox } from '../../components/Modal';
import CancelIcon from '@material-ui/icons/Cancel';
import MessageAlert from '../../components/MessageAlert';
import { useShowModal } from '../../contexts/SharedContext'
import { MySelect } from "../../components/InputSelect";
import InputMask from 'react-input-mask';
import Header from "../../components/Header"
import { MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';
import { tint } from "polished";

export default function CadastroPlanoAvaliacao(props){
    const { enqueueSnackbar } = useSnackbar();
    const { colors, textTableColor } = useContext(ThemeContext);
    const [planosAvaliacao, setPlanosAvaliacao] = useState([]);
    const [anoConsulta, setAnoConsulta] = useState('');
    const [estudoConsulta, setEstudoConsulta] = useState('');
    const [loadDialog, setLoadDialog] = useState(false);
    const { setShowModalGeral, showModalGeral } = useShowModal();
    const [estudoOptions, setEstudoOptions] = useState([]);
    const [tema, setTema] = useState(null);
    const [temaOptions, setTemaOptions] = useState([]);
    const [turmaOptions, setTurmaOptions] = useState([]);
    const [turmaConsulta, setTurmaConsulta] = useState('');
    const [dataAvaliacaoIncluir, setDataAvaliacaoIncluir] = useState('');
    const [observacaoIncluir, setObservacaoIncluir] = useState('');
    const [idToModal, setIdToModal] = useState();
    const { setShowModalAlunosTurma, showModalAlunosTurma } = useShowModal();
    const [aluno, setAluno] = useState(null);
    const [alunosOptions, setAlunosOptions] = useState([]);
    const [tableAlunos, setTableAlunos] = useState([]);
    const [observacaoAluno, setObservacaoAluno] = useState(null);
    const [dataEntrega, setDataEntrega] = useState('');

    const useStyles = makeStyles({
        wrapBtnModal: {
          alignItems: 'flex-start'
        },
        containerModal: {
          boxShadow: '0px 4px 0px 0px rgba(0, 0, 0, 0)',
          borderRadius: '0'
        },
        headColModal: {
          backgroundColor: colors.surface,
          textTransform: 'uppercase',
          borderRadius: '0',
          fontSize: '14px'
        }
    });
    const classes = useStyles();

    const handleEstudoConsulta = (item) => {
      setPlanosAvaliacao([]);
      setEstudoConsulta(item);
      getTurmas();
    }

    const handleAnoConsulta = (item) => {
      setAnoConsulta(item.target.value);
      setPlanosAvaliacao([]);
      if (anoConsulta.length >= 4) {
        getTurmas();
      }
      
    }

    const handleTurmaConsulta = (item) => {
      setPlanosAvaliacao([]);
      setTurmaConsulta(item);
    }

    const handleTema = (item) => {
      setTema(item);
    }

    const handleAlunoIncluir = (item) => {
      setAluno(item)
    }

    useEffect(() => {
      getEstudos();
    }, [])

    async function getEstudos() {
      try {
          const { data } = await api.get(`estudo`);
          setEstudoOptions(data);
      } catch (error) {
          enqueueSnackbar("Erro ao buscar Estudos", ERRORMESSAGE);
      }
    }

    async function getTurmas(showSnack=true) {
      try {
        setTurmaOptions([]);
        setTurmaConsulta([]);

        if ((anoConsulta !== '') && ((estudoConsulta !== null) && (estudoConsulta.value !== undefined) && (estudoConsulta.value !== ''))){

          if (showSnack) {const key = enqueueSnackbar('Pesquisando Turmas ...', INFOMESSAGE);};

          let params = ''
          params += `&ano=${anoConsulta}`
          params += `&idEstudo=${estudoConsulta.value}`

          setLoadDialog(true);
          const { data } = await api.get(`turma?` + params);
          setTurmaOptions(data);
          setLoadDialog(false);          
        }
      } catch (error) {
          enqueueSnackbar("Erro ao buscar Turmas", ERRORMESSAGE);
          setLoadDialog(false);
      }
  }

    const getTemasEstudo = async () => {
      try {
        setLoadDialog(true);
        const { data } = await api.get('/temaestudo?idEstudo='+estudoConsulta.value);
        setTemaOptions(data);
        setLoadDialog(false);
      } catch (err) {
        enqueueSnackbar("Erro ao buscar temas", ERRORMESSAGE);
        setLoadDialog(false);
      }
    }

    async function fetchSearch(showSnack=true) {
        try {
            let params = ''
            if ((anoConsulta === '') || (estudoConsulta === null) || (estudoConsulta.value === undefined) || (estudoConsulta.value === '')
                || (turmaConsulta === null) || (turmaConsulta.value === undefined) || (turmaConsulta.value === '')) {
              enqueueSnackbar("Informe o Estudo, o Ano e a Turma!", ERRORMESSAGE);
            }
            else {
              if (showSnack) {const key = enqueueSnackbar('Pesquisando Planos de Avaliacao ...', INFOMESSAGE);};
              params += `&idTurma=${turmaConsulta.value}`
              setLoadDialog(true);
              const { data } = await api.get(`planoavaliacao?` + params);
              setPlanosAvaliacao(data);
              setLoadDialog(false);
            }
        } catch (error) {
            enqueueSnackbar("Erro ao buscar Planos de Avaliacao", ERRORMESSAGE);
            setLoadDialog(false);
        }
    }

    function clearSearch() {
        setPlanosAvaliacao([]);
        setAnoConsulta('');
        setEstudoConsulta([]);
        setTurmaConsulta([]);
        setTurmaOptions([]);
    }

    function clearInclude() {
      setTema([]);
      setDataAvaliacaoIncluir(null);
      setObservacaoIncluir(null);
    }

    function openModal(action, item) {
      if ((turmaConsulta === null) || (turmaConsulta.value === undefined) || (turmaConsulta.value === '')) {
        enqueueSnackbar("Seleciona a turma!", ERRORMESSAGE);
      }
      else {
        clearInclude();
        getTemasEstudo();
        if (action === "insert") {
            setShowModalGeral({ show: true, title: 'INCLUIR PLANO DE AVALIAÇÃO', action: 'inserir' });
        }
        else {
            setShowModalGeral({ show: true, title: 'ALTERAR PLANO DE AVALIAÇÃO', action: 'editar', item: item });
        }
      }            
    }

    
    const handleClose = () => {
        setShowModalGeral({ show: false });
      };

    async function sendPlanoAvaliacao() {

        const key = enqueueSnackbar('Cadastrando Plano de Avaliação ...', INFOMESSAGE);
        
        try {
    
          const valoresInseridos = {
            idTurma: turmaConsulta.value,
            idTema: tema.value,
            dataAvaliacao: dataAvaliacaoIncluir,
            observacao: observacaoIncluir
          };
    
          setLoadDialog(true);
          const { data } = await api.post("/planoavaliacao/", valoresInseridos);
          if (data.message!=null) throw {message: data.message}
          enqueueSnackbar(<MessageAlert message={"Dados salvos com sucesso!"} />, SUCCESSMESSAGE);
          setShowModalGeral({ show: false });
          fetchSearch(false);
          setLoadDialog(false);
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
          setLoadDialog(false);
        }
      };
    
      async function editPlanoAvaliacao(id) {
    
        const key = enqueueSnackbar('Alterando Plano de Avaliação ...', INFOMESSAGE);
    
        try {
    
          const valoresEditados = {
            idTurma: turmaConsulta.value,
            idTema: tema.value,
            dataAvaliacao: dataAvaliacaoIncluir,
            observacao: observacaoIncluir
          };
    
          setLoadDialog(true);
          const { data } = await api.put("/planoavaliacao/" + id, valoresEditados);
          if (data.message != null) throw {message: data.message}
          enqueueSnackbar(<MessageAlert message={"Dados salvos com sucesso!"} />, SUCCESSMESSAGE);
          setShowModalGeral({ show: false });
          fetchSearch(false);
          setLoadDialog(false);
    
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
          setLoadDialog(false);
        }
      };

      useEffect(() => {
        if (showModalGeral.action === 'editar') {
            setTema({value:`${showModalGeral.item.idTema}`, label:`${showModalGeral.item.codigoTema + " - " + showModalGeral.item.nomeTema }`});
            setDataAvaliacaoIncluir(showModalGeral.item.dataAvaliacao.split("T")[0] + 'T00:00:00');
            setObservacaoIncluir(showModalGeral.item.observacao);
            setIdToModal(showModalGeral.item.id);
        }
      }, [showModalGeral.action])


    async function deletePlanoAvaliacao(item) {
        try {
          var resposta = window.confirm("Deseja remover esse registro?");
          if (resposta) {
            const key = enqueueSnackbar('Excluindo Plano de Avaliação ...', INFOMESSAGE);
            const { data } = await api.delete("/planoavaliacao/" + item.id);
            if ((data.success !== undefined) && (!data.success))
            {
              throw new Error(data.message)
            }
            enqueueSnackbar(<MessageAlert message={"Plano de Avaliação excluído com sucesso!"} />, SUCCESSMESSAGE);
            fetchSearch(false);
          }
        } catch (err) {
          enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
        }
    };

    const handleCloseAlunosTurma = () => {
      setShowModalAlunosTurma({ show: false });
    };

    function openModalAlunosTurma(item) {
       //clearInclude();
      getPessoasParaEntrega(item.id);
      getEntregasAvaliacoes(item.id);
      setIdToModal(item.id);
      setDataEntrega(new Date());
      let dataAvaliacaoModal = item.dataAvaliacao.split("-")[2].split("T")[0] + "/" + item.dataAvaliacao.split("-")[1] +"/"+ item.dataAvaliacao.split("-")[0]
      setShowModalAlunosTurma({ show: true, title: 'PRESENÇA DA TURMA - ' + dataAvaliacaoModal, action: 'editar', item: item });          
    }

    const getPessoasParaEntrega = async (idTurma) => {
      try {
        setLoadDialog(true);
        const { data } = await api.get('/entregaavaliacao/pessoasparaentrega/'+idTurma);
        setAlunosOptions(data);
        setLoadDialog(false);
      } catch (err) {
        enqueueSnackbar("Erro ao buscar dados iniciais", ERRORMESSAGE);
        setLoadDialog(false);
      }
    }

    async function getEntregasAvaliacoes(idPlanoAvaliacao) {
      //const key = enqueueSnackbar('Pesquisando Pessoas ...', INFOMESSAGE)
      try {
        const { data } = await api.get("/entregaavaliacao/" + idPlanoAvaliacao);
        if (data) {
          setTableAlunos(data);
        }
      } catch (error) {
        enqueueSnackbar("Erro ao buscar alunos", ERRORMESSAGE);
      }
    }

    async function saveEntregaAvaliacao() {

      const key = enqueueSnackbar('Cadastrando Entrega ...', INFOMESSAGE);
      
      try {        
        
        const valoresInseridos = {
          idPlanoAvaliacao: idToModal,
          idPessoa: aluno.value,
          dataEntrega: dataEntrega,
          observacao: observacaoAluno
        };
          
        setLoadDialog(true);
        const { data } = await api.post("/entregaavaliacao/", valoresInseridos);
        if (data.message!=null) throw {message: data.message}
        enqueueSnackbar(<MessageAlert message={"Dados salvos com sucesso!"} />, SUCCESSMESSAGE);
        setAluno([]);
        setObservacaoAluno("");
        getPessoasParaEntrega(idToModal);
        getEntregasAvaliacoes(idToModal);
        setLoadDialog(false);
      } catch (err) {
        enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
        setLoadDialog(false);
      }
    };

    async function deleteEntregaAvaliacao(idPlanoAvaliacao,idPessoa) {
      try {
        var resposta = window.confirm("Deseja remover esse registro?");
        if (resposta) {
          const key = enqueueSnackbar('Excluindo Turma ...', INFOMESSAGE);
          const { data } = await api.delete("/entregaavaliacao/" + idPlanoAvaliacao + "/" + idPessoa);
          if ((data.success !== undefined) && (!data.success))
          {
            throw new Error(data.message)
          }
          enqueueSnackbar(<MessageAlert message={"Entrega excluída com sucesso!"} />, SUCCESSMESSAGE);
          fetchSearch(false);
          getPessoasParaEntrega(idPlanoAvaliacao);
          getEntregasAvaliacoes(idPlanoAvaliacao);
          setLoadDialog(false);
        }
      } catch (err) {
        enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
      }
    };

    const bodyPlanoAvaliacao = (
        <StyledBox className={'disableFocus alert-modal'}>
          <TitleStyle2>
            {showModalGeral.title}
            <CancelIcon
              style={modalClose}
              color={colors.error}
              size="20"
              title="Fechar"
              onClick={() => handleClose()}
            />
          </TitleStyle2>
          <ModalBox>
            <Wrap>
                <WrapInput style={{ position: 'relative', width: '18%'}}>
                <LabelInput style={{padding: '0.7px'}}>Data da Avaliacao <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <KeyboardDatePicker 
                    value={dataAvaliacaoIncluir} 
                    onChange={setDataAvaliacaoIncluir}
                    format="dd/MM/yyyy"
                    clearLabel="Limpar"
                    cancelLabel="Cancelar"
                    clearable
                    minDateMessage="Não é possível buscar por datas anteiores a 01/01/1900."
                    invalidDateMessage="A data inserida não é válida!"
                    helperText={""}
                    id="dataAvaliacao"
                    //maxDate={new Date(new Date())}
                    margin="dense"
                    inputVariant="outlined"
                    KeyboardButtonProps={{
                    "aria-label": "change date",
                    }}
                />
                </MuiPickersUtilsProvider>
            </WrapInput>           
            <WrapInput style={{ position: 'relative', width: '70%'}}>
                <LabelInput>Tema <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                <MySelect
                styles={multSelect}
                placeholder={'Selecione o tema...'}
                value={tema}
                isClearable={true}
                isSearchable={true}
                onChange={handleTema}
                options={temaOptions.map((item) => { return { value: item.id, label: item.codigo + " - " + item.nome}; })}
                />
            </WrapInput>
            </Wrap>             
            <Wrap>
              <WrapInput style={{ position: 'relative', width: '70%'}}>
                <LabelInput>Observação</LabelInput>
                <Input
                  placeholder="Inserir observações"
                  style={inputStyle}
                  maxLength="2000"
                  type="text"
                  name="observacao"
                  onChange={e => setObservacaoIncluir(e.target.value)}
                  value={observacaoIncluir}
                />
              </WrapInput>
            </Wrap>
            <Wrap>
              <WrapInput className="wrapInputModal">
                <Items>
                  <CancelarBtn type="button" onClick={handleClose}> Cancelar </CancelarBtn>
                  <Button type="button" onClick={() => showModalGeral.action === 'inserir' ? sendPlanoAvaliacao() : editPlanoAvaliacao(idToModal)} > Salvar </Button>
                </Items>
              </WrapInput>
            </Wrap>
          </ModalBox>
        </StyledBox>
      );

      const bodyAlunosTurma = (
        <StyledBox className={'disableFocus alert-modal'}>
          <TitleStyle2>
            {showModalAlunosTurma.title}
            <CancelIcon
              style={modalClose}
              color={colors.error}
              size="20"
              title="Fechar"
              onClick={() => handleCloseAlunosTurma()}
            />
          </TitleStyle2>
          <ModalBox>
            <Wrap style={{ position: 'relative', padding: '1px', width:'97%' }}>
              <WrapInput style={{ position: 'relative', width: '50%', marginLeft: '0px'}}>
                  <LabelInput>Pessoas <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                  <MySelect
                    styles={multSelect}
                    placeholder={'Opções...'}
                    value={aluno}
                    isClearable={true}
                    isSearchable={true}
                    onChange={handleAlunoIncluir}
                    options={alunosOptions.map((item) => { return { value: item.id, label: item.nome}; })}
                  />
              </WrapInput>
                <WrapInput style={{ position: 'relative', width: '30%', marginLeft: '0px' }}>
                    <LabelInput style={{padding: '0.7px'}}>Data da Entrega <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <KeyboardDatePicker 
                        value={dataEntrega} 
                        onChange={setDataEntrega}
                        format="dd/MM/yyyy"
                        clearLabel="Limpar"
                        cancelLabel="Cancelar"
                        clearable
                        minDateMessage="Não é possível buscar por datas anteiores a 01/01/1900."
                        invalidDateMessage="A data inserida não é válida!"
                        helperText={""}
                        id="dataEntrega"
                        maxDate={new Date(new Date())}
                        margin="dense"
                        inputVariant="outlined"
                        KeyboardButtonProps={{
                        "aria-label": "change date",
                        }}
                        />
                    </MuiPickersUtilsProvider>
                </WrapInput>
            </Wrap>
            <Wrap style={{ position: 'relative', padding: '1px', width:'99%'  }}>
              <WrapInput style={{ position: 'relative', width: '80%'}}>
                  <LabelInput>Observações</LabelInput>
                  <Input
                    placeholder="Inserir Observações"
                    style={inputStyle}
                    maxLength="500"
                    type="text"
                    name="observacaoAluno"
                    onChange={e => setObservacaoAluno(e.target.value)}
                    value={observacaoAluno}
                  />
              </WrapInput>
            </Wrap>
            <Wrap>
              <WrapInput className="wrapInputModal" >
                <Items style={{height: '16px'}}>
                  <CancelarBtn className='widthButton' type="button" onClick={handleCloseAlunosTurma}> Sair </CancelarBtn>
                  <Button style={{ backgroundColor: '#3FC248' }} className='widthButton' type="button" onClick={() => saveEntregaAvaliacao()}>&nbsp;Adicionar<AddIcon></AddIcon></Button>
                </Items>
              </WrapInput>
            </Wrap>
            <WrapList>
              {
                <BodyList style={{ width: '93%', height: '35vh'}}>
                <TableContainer className={classes.containerModal}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.headColModal} align="center">Aluno</TableCell>
                        <TableCell className={classes.headColModal} align="center">Data</TableCell>
                        <TableCell className={classes.headColModal} align="center">Obs</TableCell>
                        <TableCell className={classes.headColModal} align="center">Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ width: '90%', backgroundColor: 'white' }}>
                      {
                        tableAlunos && tableAlunos.map((row, index) => {
                          return (
                            <TableRow style={{ backgroundColor: index % 2 === 0 ? shade(0.1, colors.surface) : '' }} key={index}>
                              <TableCell align="center">
                                {row.nomeAluno}
                              </TableCell>
                              <TableCell align="center">
                                {row.dataEntrega}
                              </TableCell>
                              <TableCell align="center">
                                {row.observacao}
                              </TableCell>
                              <TableCell align="center">
                                <AiTwotoneDelete
                                  style={{ cursor: "pointer", marginLeft: "5px" }}
                                  color={tint(0.1, colors.error)}
                                  size="20"
                                  title="Remover"
                                  onClick={() => deleteEntregaAvaliacao(row.idPlanoAvaliacao,row.idPessoa)}
                                />
                              </TableCell>
                            </TableRow>
                          )
                        })
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                </BodyList>
                }
            </WrapList>
          </ModalBox>
        </StyledBox>
      );
    

    const modalLoad = (
        <div className={'disabeFocus alert-modal'}>
            <WrapInput className="alertText" style={{ alignItems: 'center' }}>
            <CircularProgress style={{ color: '#043D5D' }} /> <h3>Carregando...</h3>
            </WrapInput>
        </div>
    );

    return (
        <Container>
          <Header/>
            <Modal open={showModalGeral.show}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
            {bodyPlanoAvaliacao}
            </Modal>
            <Modal open={showModalAlunosTurma.show}
                onClose={handleCloseAlunosTurma}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
            {bodyAlunosTurma}
            </Modal>
            <SearchBox style={{ margin: '20px 0 20px 0' }}>
                <TitleStyle2>Pesquisa de Planos de Avaliações</TitleStyle2>
                <Wrap>
                <WrapInput style={{ width: '25%', paddingRight: '1px' }}> <LabelInput> Estudo <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                  <MySelect
                    styles={multSelect}
                    placeholder={'Selecione o estudo...'}
                    value={estudoConsulta}
                    isClearable={true}
                    isSearchable={true}
                    onChange={handleEstudoConsulta}
                    onBlur={getTurmas}
                    options={estudoOptions.map((item) => { return { value: item.id, label: item.nome }; })}
                  />
                </WrapInput>
                <WrapInput style={{ width: '8%', paddingRight: '5px' }}> <LabelInput> Ano <span style={{ color: '#FF0000' }}>*</span> </LabelInput>
                <InputMask
                    mask="9999"
                    maskChar=""
                    placeholder="Informe o Ano"
                    style={inputStyle}
                    type="text"
                    name="anoConsulta"
                    onChange={handleAnoConsulta}
                    onBlur={getTurmas}
                    value={anoConsulta}
                  />
                </WrapInput>
                <WrapInput style={{ width: '20%', paddingRight: '1px' }}> <LabelInput> Turma <span style={{ color: '#FF0000' }}>*</span></LabelInput>
                  <MySelect
                    styles={multSelect}
                    placeholder={'Selecione a turma...'}
                    value={turmaConsulta}
                    isClearable={true}
                    isSearchable={true}
                    onChange={handleTurmaConsulta}
                    options={turmaOptions.map((item) => { return { value: item.id, label: item.codigo }; })}
                  />
                </WrapInput>
                <WrapInput style={{ width:'40%', marginTop: '10px' }}>
                    <ItemsSearch>
                    <IconeSearch size={25} title="Pesquisar" onClick={() => fetchSearch(true)} />
                    <Button style={{ backgroundColor: '#3FC248' }} className='widthButton' onClick={() => openModal('insert')}>&nbsp;Novo<AddIcon></AddIcon></Button>
                    <Button className='widthButton' onClick={() => clearSearch()}>&nbsp;Limpar<DeleteOutlineIcon></DeleteOutlineIcon></Button>
                    </ItemsSearch>
                </WrapInput>
                </Wrap>
            </SearchBox>
            <WrapList>
                <HeaderList>
                <span style={{ marginLeft: '20px' }}> PLANOS DE AVALIAÇÕES</span>
                </HeaderList>
                {
                <BodyList>
                    <TableContainer>
                        <Table style={{ backgroundColor: colors.surface, width: '100%' }} className={classes.table} size="small">
                            <TableHead>
                            <TableRow>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">TEMA</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">DATA</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">OBSERVAÇÃO</TableCell>
                                <TableCell className={classes.head} style={{ color: textTableColor, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center">AÇÕES</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody style={{ width: '100%' }}>
                            {
                                planosAvaliacao && planosAvaliacao.map((row, index) => {
                                return (
                                    <TableRow style={{ backgroundColor: index % 2 === 0 ? shade(0.1, colors.surface) : '' }} key={index}>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.codigoTema + " - " + row.nomeTema}</TableCell>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.dataAvaliacao.split("-")[2].split("T")[0] + "/" + row.dataAvaliacao.split("-")[1] +"/"+ row.dataAvaliacao.split("-")[0]}</TableCell>
                                        <TableCell style={{ color: textTableColor, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">{row.observacao}</TableCell>
                                        <TableCell
                                            style={{ color: textTableColor, border: 'none', display: 'flex', justifyContent: 'center' }}
                                            align="center">
                                            <AiOutlineEdit
                                            onClick={() => openModal('update',row)}
                                            style={{ cursor: "pointer", marginLeft: '5px'  }}
                                            color={colors.primary}
                                            size="22"
                                            title="Editar"
                                            />          
                                            <AiOutlineDelete
                                            onClick={() => deletePlanoAvaliacao(row)}
                                            style={{ cursor: "pointer", marginLeft: '5px'  }}
                                            color={colors.primary}
                                            size="22"
                                            title="Excluir"
                                            />
                                            <AiOutlineTeam
                                            onClick={() => openModalAlunosTurma(row)}
                                            style={{ cursor: "pointer", marginLeft: '5px'  }}
                                            color={colors.primary}
                                            size="22"
                                            title="Entregas"
                                            />                            
                                        </TableCell>
                                    </TableRow>
                                    )
                                    })
                                }
                                </TableBody>
                        </Table>
                    </TableContainer >
 
                </BodyList>  
                }
            </WrapList>
            <Modal open={loadDialog}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {modalLoad}
            </Modal>
        </Container>
    )
}